// extracted by mini-css-extract-plugin
export var labelWrapper = "_hf-0";